// TODO: use Map instead object
export const Languages = {
  zh: {
    id: "zh" as "zh",
    name: "中文" as "中文",
    shortname: "中文" as "中文",
  },
  da: {
    id: "da" as "da",
    name: "Dansk" as "Dansk",
    shortname: "da" as "da",
  },
  de: {
    id: "de" as "de",
    name: "Deutsch" as "Deutsch",
    shortname: "de" as "de",
  },
  en: {
    id: "en" as "en",
    name: "English" as "English",
    shortname: "en" as "en",
  },
  es: {
    id: "es" as "es",
    name: "Español" as "Español",
    shortname: "es" as "es",
  },
  fr: {
    id: "fr" as "fr",
    name: "Français" as "Français",
    shortname: "fr" as "fr",
  },
  it: {
    id: "it" as "it",
    name: "Italiano" as "Italiano",
    shortname: "it" as "it",
  },
  pt: {
    id: "pt" as "pt",
    name: "Português" as "Português",
    shortname: "pt" as "pt",
  },
  ru: {
    id: "ru" as "ru",
    name: "Русский" as "Русский",
    shortname: "ру" as "ру",
  },
}
export const DEFAULT_LANG = "en"
export const DEFAULT_DATING_LANG = "en"

export type LanguageISO = keyof typeof Languages
